import React, { useState, useMemo, useEffect } from 'react'
import { useMediaQuery } from '@material-ui/core'
import {
    DialogPdf,
    LabelHLPure,
    InputHLPure,
    ButtonHLPure,
    TextAreaHLPure,
    InputFileHLPure,
    ButtonAddHLPure,
    ComboBoxTemplatePure,
    DocumentsToRequireClassifyModal
} from '../../../pures'
import { useTranslation } from 'react-i18next'
import PdfViewerAction from '../../../actions/pdf-viewer/pdf-viewer.action'

import './documents-to-require-add-new-document.view.css'
import { b64toBlob } from '../../../../validators'
import moment from 'moment'
import { convertToStandarDate } from '../../../../utils'
import { ChipList, Chip } from '@progress/kendo-react-buttons'

const DocumentsToRequireAddDocumentView = ({
    selectedValueFilter,
    validators,
    createClientDocument,
    token,
    typeDocuments,
    preferenceValue,
    handleFile,
    handleDeleteFile,
    selectedFile,
    selectedFileName,
    errorFile,
    selectedFileBase64,
    newOptions,
    handleChangePage,
    personTypes,
    nameComponentUser,
    selectedUser,
    updateClientDocument,
    toggleDialogYesNo,
    language,
    availableGroups,
    createGroup,
    user,
    showLoadingRequesting,
    showCompletedRequesting,
    shouldReopenClassifyModal,
    isCreatingDocument,
    clearReopenClassifyModal
}) => {
    const { t } = useTranslation()
    let ENV = process.env
    const [documentName, setDocumentName] = useState('')
    const [documentDescription, setDocumentDescription] = useState('')
    const [documentTypeId, setDocumentTypeId] = useState('Sin clasificación')
    const [errorInDocumentName, setErrorInDocumentName] = useState(undefined)
    const [errorInDescription, setErrorInDescription] = useState(undefined)
    const [typeDocument, setTypeDocument] = useState('')
    const [ocrCheck, setOcrCheck] = useState(false)
    const [blobUrl, setBlobUrl] = useState('')
    const [typeSelectedTitle, setTypeSelectedTitle] = useState('')
    const [nameView, setNameView] = useState('add')
    const [urlPdf, setUrlPdf] = useState('')
    const [showPDFAWS, setShowPDFAWS] = useState(false)
    const [valueFilter, setValueFilter] = useState(t('documentsToRequire.document.type.key.all'))
    const [errorFilter, setErrorFilter] = useState(false)
    const [labelmodifiedDate, setLabelModifiedDate] = useState('')

    const pdf = useMemo(() => {
        const pdfUrl = selectedFileBase64 ? `data:application/pdf;base64,${selectedFileBase64}` : ''
        return <PdfViewerAction url={pdfUrl} isExtended={false} isSSRActive={false} />
    }, [selectedFileBase64])
    const pdfAWS = useMemo(() => <PdfViewerAction url={urlPdf} isExtended={false} isSSRActive={false} />, [urlPdf])
    // Estados para clasificación por grupos
    const [selectedGroups, setSelectedGroups] = useState([])
    const [showGroupsModal, setShowGroupsModal] = useState(false)

    // Estados de validacion form
    const [hasSubmitted, setHasSubmitted] = useState(false)
    const [errorDocumentName, setErrorDocumentName] = useState(false)
    const [errorGroups, setErrorGroups] = useState(false)
    const [errorTypeDocument, setErrorTypeDocument] = useState(false)

    const sortedTypeDocuments = useMemo(() => {
        const list = Array.isArray(typeDocuments) ? [...typeDocuments] : []
        return list.sort((a, b) => (a?.name || '').localeCompare(b?.name || '', undefined, { sensitivity: 'base' }))
    }, [typeDocuments])

    const isMobile = useMediaQuery('(max-width:560px)')
    const matches = useMediaQuery('(max-width:820px)')

    const isDisabled = selectedUser?.default === true

    const DIGITAL_LIBRARY_ALLOWED_ROLES = [
        process.env.REACT_APP_ADMIN,
        process.env.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_ADMIN,
        process.env.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_LAWYER,
        process.env.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_LAWYER_AUTH
    ]

    const canCreateGroups = useMemo(() => {
        const roles = user?.userMetaData?.userRoles || []

        return roles.some(r =>
            DIGITAL_LIBRARY_ALLOWED_ROLES.includes(r?.role?.key)
        )
    }, [user])

    /**
     * @function handleOpenGroupsModal
     * Abre el modal de selección de grupos
     * @returns {void}
     */
    const handleOpenGroupsModal = () => {
        setShowGroupsModal(true)
    }

    /**
     * @function handleCloseGroupsModal
     * Cierra el modal de selección de grupos
     * @returns {void}
     */
    const handleCloseGroupsModal = () => {
        setShowGroupsModal(false)
    }

    /**
     * @function handleSaveGroups
     * Guarda los grupos seleccionados
     * @param {Array} groups - Grupos seleccionados del modal
     * @returns {void}
     */
    const handleSaveGroups = (groups) => {
        setSelectedGroups(groups)
    }

    /**
     * @function handleDeleteChipGroup
     * Elimina un grupo de la selección
     * @param {Object} groupToRemove - Grupo a eliminar
     * @returns {void}
     */
    const handleDeleteChipGroup = (groupToRemove) => {
        setSelectedGroups(prevGroups =>
            prevGroups.filter(group => group.id !== groupToRemove.id)
        )
    }

    /**
     * @function handleCreateGroup
     * Crea un nuevo grupo y lo agrega a la lista disponible
     * @param {Object} newGroup - Nuevo grupo creado
     * @returns {void}
     */
    const handleCreateGroup = async (newGroup) => {
        if (!createGroup) return
        setShowGroupsModal(false)

        await createGroup(newGroup)
    }

    useEffect(() => {
        if (!nameComponentUser) return
        const view = nameComponentUser === t('documentsToRequire.newDocument') ? 'add' : 'edit'
        setNameView(view)
        if (view === 'add') {
            setDocumentName('')
            setDocumentDescription('')
            setDocumentTypeId('Sin clasificación')
            setErrorInDocumentName(undefined)
            setErrorInDescription(undefined)
            setTypeDocument('')
            setErrorTypeDocument(false)
            setOcrCheck(false)
            setBlobUrl('')
            setTypeSelectedTitle('')
            setUrlPdf('')
            setShowPDFAWS(false)
            setValueFilter(t('documentsToRequire.document.type.key.all'))
            setErrorFilter(false)
            setLabelModifiedDate('')
            setSelectedGroups([])
        }
    }, [nameComponentUser, t])

    useEffect(() => {
        if (!nameComponentUser) return

        const valueFilter = (nameComponentUser === t('documentsToRequire.newDocument')) ? selectedValueFilter : (selectedUser.documentTypes && selectedUser.documentTypes.key) ? selectedUser.documentTypes.key : ''
        // Inline title computation to avoid hook dependency issues
        let title = t('documentsToRequire.classifiedForAll')
        if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_KEY) {
            title = t('documentsToRequire.classifiedForPhysical')
        } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_MORAL_KEY) {
            title = t('documentsToRequire.classifiedForMoral')
        } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_REPSE_PHYSICAL_KEY) {
            title = t('documentsToRequire.classifiedForREPSEPhysical')
        } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_REPSE_MORAL_KEY) {
            title = t('documentsToRequire.classifiedForREPSEMoral')
        } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_CONTRACT_REPSE_KEY) {
            title = t('documentsToRequire.classifiedForContractREPSE')
        } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_REPORT_REPSE_KEY) {
            title = t('documentsToRequire.classifiedForReporREPSE')
        } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_PROCEDURE_USER_KEY) {
            title = t('documentsToRequire.classifiedProcedureUser')
        } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_SIGNERS_KEY) {
            title = t('documentsToRequire.classifiedForSigners')
        } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_ASSEMBLIES_KEY) {
            title = t('documentsToRequire.classifiedForAssemblies')
        }
        setValueFilter(valueFilter)
        setTypeSelectedTitle(title)
    }, [
        selectedValueFilter,
        nameComponentUser,
        selectedUser,
        t,
        ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_KEY,
        ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_MORAL_KEY,
        ENV.REACT_APP_PERSON_TYPE_REPSE_PHYSICAL_KEY,
        ENV.REACT_APP_PERSON_TYPE_REPSE_MORAL_KEY,
        ENV.REACT_APP_PERSON_TYPE_CONTRACT_REPSE_KEY,
        ENV.REACT_APP_PERSON_TYPE_REPORT_REPSE_KEY,
        ENV.REACT_APP_PERSON_TYPE_PROCEDURE_USER_KEY,
        ENV.REACT_APP_PERSON_TYPE_SIGNERS_KEY,
        ENV.REACT_APP_PERSON_TYPE_ASSEMBLIES_KEY
    ])

    useEffect(() => {
        if (!selectedUser || !selectedUser.name) return
        moment.locale(language)
        const name = (selectedUser.name) ? selectedUser.name : ''
        const description = (selectedUser.description) ? selectedUser.description : ''
        const typeDocument = (selectedUser.typeDocument) ? selectedUser.typeDocument : 0
        const sendOCR = (selectedUser.sendOCR) ? selectedUser.sendOCR : false
        const path = (selectedUser.pathDocument) ? selectedUser.pathDocument : ''
        const showPDF = (path) ? true : false
        const updatedByUser = (selectedUser.updatedByUser) ? selectedUser.updatedByUser : ''
        let convertDate = convertToStandarDate(selectedUser.updatedDateBD, language)
        const updatedDate = (selectedUser.updatedDate && convertDate !== 'invalid date') ? convertDate : selectedUser.updatedDate || ''
        const labelModifiedDate = (selectedUser.updatedByUser && selectedUser.updatedDate) ? `${t('documentsToRequire.labels.modifiedBy', { updatedByUser, updatedDate })}` : ''
        const optionsId = (selectedUser.clientDocumentTypeRequestId) ? selectedUser.clientDocumentTypeRequestId : 'Sin clasificación'

        const existingGroups = selectedUser.groups || []
        if (existingGroups.length > 0) {
            setSelectedGroups(existingGroups)
        }

        const selectedTypeDocument = sortedTypeDocuments.find(
            (td) => td.id === selectedUser.typeDocumentId
        ) || null

        setDocumentName(name)
        setDocumentDescription(description)
        setTypeDocument(selectedTypeDocument)
        setOcrCheck(sendOCR)
        setUrlPdf(path)
        setShowPDFAWS(showPDF)
        setLabelModifiedDate(labelModifiedDate)
        setDocumentTypeId(optionsId)
    }, [selectedUser, language, t])

    useEffect(() => {
        if (selectedFileBase64) {
            const blob = b64toBlob(selectedFileBase64, 'application/pdf')
            setBlobUrl(blob)
        }
    }, [selectedFileBase64])

    useEffect(() => {
        if (!shouldReopenClassifyModal) return
        if (showLoadingRequesting) return
        if (showCompletedRequesting) return
        setShowGroupsModal(true)
        clearReopenClassifyModal()
    }, [shouldReopenClassifyModal, showLoadingRequesting, showCompletedRequesting])

    const onHandlerFilter = (e) => {
        const value = e.target.value
        setValueFilter(value)
        setErrorFilter(false)
    }

    const handleChangeDropdown = (e) => {
        setDocumentTypeId(e.target.value)
    }

    const handleChangeDocumentName = (e) => {
        setDocumentName(e.target.value)
        if (hasSubmitted) {
            setErrorDocumentName(false)
        }
    }

    const handleChangeDocumentDescription = (e) => {
        setDocumentDescription(e.target.value)
    }

    const handleChangeTypeDocument = (e) => {
        setErrorTypeDocument(false)
        setTypeDocument(e.value ?? null)
    }

    const onChangeCheckBoxOCR = (e) => {
        setOcrCheck(e.target.checked)
    }

    const handleBack = () => {
        handleDeleteFile()
        handleChangePage(false, '')
    }


    const handleUploadFile = (e) => {
        setShowPDFAWS(false)
        handleFile(e)
    }

    const onHandleSubmit = () => {
        setHasSubmitted(true)

        let hasError = false

        if (!documentName.trim()) {
            setErrorDocumentName(true)
            hasError = true
        } else {
            setErrorDocumentName(false)
        }

        if (!typeDocument) {
            setErrorTypeDocument(true)
            hasError = true
        } else {
            setErrorTypeDocument(false)
        }

        if (hasError) return

        let personTypeId = ''
        if (valueFilter === ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_KEY) {
            personTypeId = Number(ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_ID)
        } else if (valueFilter === ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_MORAL_KEY) {
            personTypeId = Number(ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_MORAL_ID)
        } else if (valueFilter === ENV.REACT_APP_PERSON_TYPE_REPSE_PHYSICAL_KEY) {
            personTypeId = Number(ENV.REACT_APP_PERSON_TYPE_REPSE_PHYSICAL_ID)
        } else if (valueFilter === ENV.REACT_APP_PERSON_TYPE_REPSE_MORAL_KEY) {
            personTypeId = Number(ENV.REACT_APP_PERSON_TYPE_REPSE_MORAL_ID)
        } else if (valueFilter === ENV.REACT_APP_PERSON_TYPE_CONTRACT_REPSE_KEY) {
            personTypeId = Number(ENV.REACT_APP_PERSON_TYPE_CONTRACT_REPSE_ID)
        } else if (valueFilter === ENV.REACT_APP_PERSON_TYPE_REPORT_REPSE_KEY) {
            personTypeId = Number(ENV.REACT_APP_PERSON_TYPE_REPORT_REPSE_ID)
        } else if (valueFilter === ENV.REACT_APP_PERSON_TYPE_PROCEDURE_USER_KEY) {
            personTypeId = Number(ENV.REACT_APP_PERSON_TYPE_PROCEDURE_USER_ID)
        } else if (valueFilter === ENV.REACT_APP_PERSON_TYPE_SIGNERS_KEY) {
            personTypeId = Number(ENV.REACT_APP_PERSON_TYPE_SIGNERS_ID)
        } else if (valueFilter === ENV.REACT_APP_PERSON_TYPE_ASSEMBLIES_KEY) {
            personTypeId = Number(ENV.REACT_APP_PERSON_TYPE_ASSEMBLIES_ID)
        }

        let invalidDocumentName = validators.documentNameValidator(documentName.trim())
        let invalidDescription = validators.documentDescriptionValidator(documentDescription)

        if (!documentName.trim()) {
            setErrorDocumentName(true)
            return
        }

        if (!typeDocument) {
            setErrorTypeDocument(true)
            return
        }

        if (invalidDocumentName !== '') {
            setErrorInDocumentName(true)
            return
        } else {
            setErrorInDocumentName(false)
        }

        if (invalidDescription !== '') {
            setErrorInDescription(true)
            setErrorInDescription(true)
            return
        }
        else {
            setErrorInDescription(false)
        }

        if (!typeDocument) {
            setErrorTypeDocument(true)
            return
        }

        let clientDocumentTypeRequestIdSend = (documentTypeId && documentTypeId !== 'Sin clasificación') ? Number(documentTypeId) : 0

        const groupsFormatted = availableGroups.map(group => ({
            id: group.id,
            name: group.name,
            value: selectedGroups.some(g => g.id === group.id)
        }))

        const body = {
            name: documentName,
            description: documentDescription || null,
            typeDocumentId: typeDocument.id,
            groups: groupsFormatted
        }
        if (nameView === 'add') {
            createClientDocument(body, token)
            return
        }
        body.documentId = selectedUser.id
        createClientDocument(body, token)

    }

    const getTitleByFilter = (value) => {
        let typeSelectedTitle = t('documentsToRequire.classifiedForAll')
        if (value === ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_KEY) {
            typeSelectedTitle = t('documentsToRequire.classifiedForPhysical')
        } else if (value === ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_MORAL_KEY) {
            typeSelectedTitle = t('documentsToRequire.classifiedForMoral')
        } else if (value === ENV.REACT_APP_PERSON_TYPE_REPSE_PHYSICAL_KEY) {
            typeSelectedTitle = t('documentsToRequire.classifiedForREPSEPhysical')
        } else if (value === ENV.REACT_APP_PERSON_TYPE_REPSE_MORAL_KEY) {
            typeSelectedTitle = t('documentsToRequire.classifiedForREPSEMoral')
        } else if (value === ENV.REACT_APP_PERSON_TYPE_CONTRACT_REPSE_KEY) {
            typeSelectedTitle = t('documentsToRequire.classifiedForContractREPSE')
        } else if (value === ENV.REACT_APP_PERSON_TYPE_REPORT_REPSE_KEY) {
            typeSelectedTitle = t('documentsToRequire.classifiedForReporREPSE')
        } else if (value === ENV.REACT_APP_PERSON_TYPE_PROCEDURE_USER_KEY) {
            typeSelectedTitle = t('documentsToRequire.classifiedProcedureUser')
        } else if (value === ENV.REACT_APP_PERSON_TYPE_SIGNERS_KEY) {
            typeSelectedTitle = t('documentsToRequire.classifiedForSigners')
        } else if (value === ENV.REACT_APP_PERSON_TYPE_ASSEMBLIES_KEY) {
            typeSelectedTitle = t('documentsToRequire.classifiedForAssemblies')
        }

        return typeSelectedTitle
    }

    return (
        <div className='documentsToRequireAddDocumentView-container'>
            <div className='documentsToRequireAddDocumentView-elements-container-flex'>
                <div className='documentsToRequireAddDocumentView-elements-container'>
                    <InputHLPure
                        labelInput={t('documentsToRequire.documentName')}
                        valueInput={documentName}
                        tooltipShow={true}
                        inputActive
                        required
                        positionTooltip={isMobile ? 'top' : 'right'}
                        titleTooltip={t('documentsToRequire.tooltipTitle')}
                        descriptionTooltip={`${t('documentsToRequire.tooltipDocumentName')} ${t('documentsToRequire.validCharactersDescription')}`}
                        informationIcon={true}
                        handleChangeInput={(e) => handleChangeDocumentName(e)}
                        errorInput={errorInDocumentName}
                        errorInputText={t('documentsToRequire.hintErrorMesaggeInDocument')}
                        disabled={isDisabled || isCreatingDocument}
                    />
                    {hasSubmitted && errorDocumentName && (
                        <p className="labelErrorPure-label">
                            {t('documentsToRequire.hintErrorMesaggeInDocument')}
                        </p>
                    )}

                    <div className='documentsToRequireAddDocumentView-groups-section'>
                        <div className='documentsToRequireAddDocumentView-groups-header'>
                            <LabelHLPure text={t('documentsToRequire.modal.classify.in')} />
                            {
                                !selectedUser.default && (
                                    <ButtonAddHLPure
                                        nameBtn={t('documentsToRequire.modal.add.group')}
                                        iconAdd
                                        onClickBtn={handleOpenGroupsModal}
                                    />
                                )
                            }
                        </div>
                        {selectedGroups.length > 0 && (
                            <div className='documentsToRequireAddDocumentView-chips-container'>
                                <ChipList
                                    selection='multiple'
                                    data={selectedGroups}
                                    textField='name'
                                    chip={(props) => (
                                        <Chip
                                            {...props}
                                            type='info'
                                            removable={!isDisabled}
                                            onRemove={!isDisabled ? () => handleDeleteChipGroup(props.dataItem) : undefined}
                                        />
                                    )}
                                />
                            </div>
                        )}
                        <ComboBoxTemplatePure
                            title={t('documentsToRequire.type.document')}
                            placeholder={t('documentsToRequire.type.document.placeholder')}
                            allowCustom={false}
                            data={sortedTypeDocuments}
                            textField='name'
                            dataItemKey='id'
                            value={typeDocument}
                            onChange={(e) => handleChangeTypeDocument(e)}
                            required
                            validityStyles={false}
                            errorCombobox={errorTypeDocument}
                            tooltipShow={true}
                            errorMessage={t('documentsToRequire.type.document.error')}
                            positionTooltip={isMobile ? 'top' : 'right'}
                            titleTooltip={t('documentsToRequire.type.document')}
                            descriptionTooltip={t('documentsToRequire.type.document.description')}
                            informationIcon={true}
                            disabled={isDisabled}
                        />
                        <TextAreaHLPure
                            labelTextArea={t('documentsToRequire.documentDescription')}
                            valueTextData={documentDescription}
                            handleChangeTextArea={(e) => handleChangeDocumentDescription(e)}
                            errorInput={errorInDescription}
                            errorTextArea={t('documentsToRequire.hintErrorMesaggeInDescription')}
                            tooltipShow
                            informationIcon
                            positionTooltip={isMobile ? 'top' : 'right'}
                            titleTooltip={t('documentsToRequire.documentDescription')}
                            descriptionTooltip={`${t('documentsToRequire.tooltipDocumentDescription')} ${t('documentsToRequire.validCharactersDescription')}`}
                            disabled={isDisabled}
                        />
                        {labelmodifiedDate &&
                            <div className='documentsToRequireAddDocumentView-modifiedDate'>
                                <LabelHLPure text={labelmodifiedDate} />
                            </div>
                        }
                        {
                            preferenceValue && selectedValueFilter && selectedValueFilter === process.env.REACT_APP_PERSON_TYPE_PROCEDURE_USER_KEY && (
                                <div className='documentsToRequire-procedure-user'>
                                    <InputFileHLPure
                                        messageBtn={t('documentsToRequire.btn.file')}
                                        flex={true}
                                        acceptFile={'application/pdf'}
                                        selectedFile={selectedFile}
                                        selectedFileName={selectedFileName}
                                        errorFile={errorFile}
                                        handleFile={(e) => handleUploadFile(e)}
                                        handleDeleteFile={(e) => handleDeleteFile(e)}
                                    />
                                    <div className='documentsToRequire-documentPDF'>
                                        {showPDFAWS && (pdfAWS)}
                                        {(selectedFile && !showPDFAWS) && (pdf)}
                                    </div>
                                    <div className='documentsToRequire-pdf-btn'>
                                        <DialogPdf blobUrl={blobUrl} />
                                    </div>
                                </div>
                            )
                        }
                        <div className='documentsToRequireAddDocumentView-btns'>
                            <ButtonHLPure
                                nameBtn={t('documentsToRequire.returnButton')}
                                onClickBtn={() => handleBack()}
                            />
                            {nameView === 'edit' && !selectedUser.default && (
                                <ButtonHLPure
                                    secondary
                                    nameBtn={t('documentsToRequire.deleteDocumentButton')}
                                    onClickBtn={() => toggleDialogYesNo(selectedUser, true)}
                                />
                            )
                            }
                            {
                                (nameView === 'add' || (nameView === 'edit' && !selectedUser.default)) && (
                                    <ButtonHLPure
                                        primary
                                        nameBtn={t('documentsToRequire.saveNewDocument')}
                                        onClickBtn={onHandleSubmit}
                                    />
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>

            {showGroupsModal && !showLoadingRequesting && !showCompletedRequesting && (
                <DocumentsToRequireClassifyModal
                    showModal
                    onClose={handleCloseGroupsModal}
                    onSave={handleSaveGroups}
                    initialSelectedGroups={selectedGroups}
                    availableGroups={availableGroups}
                    canCreateGroups={canCreateGroups}
                    onCreateGroup={handleCreateGroup}
                />
            )}
        </div>
    )
}

export default DocumentsToRequireAddDocumentView
